import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const WarningModal = ({ isOpen, onClose }) => {
    return (
        <Modal
            show={isOpen}
            onHide={onClose}
            centered
            backdrop="static"
            keyboard={false}
            style={{ zIndex: 9999 }}
        >
            <Modal.Header style={{ backgroundColor: '#0068BD' }} closeButton={false}>
                <Modal.Title style={{ color: '#fff', fontSize: '14px', fontWeight: '400' }}>
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                    WARNING
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-0" style={{ fontSize: '14px' }}>
                    This tool is for internal use only. Not to be exported or sent to anyone external.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button 
                    variant="primary" 
                    onClick={() => {
                        onClose();
                    }}
                    style={{ backgroundColor: '#0068BD', borderColor: '#0068BD' }}
                >
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default WarningModal;
